import React from 'react';
import { AlertTriangle } from 'lucide-react';

const GuardrailWarning = ({ type = 'warning', title, children }) => {
  const className = `guardrail-${type}`;
  
  return (
    <div className={`guardrail ${className}`}>
      <div className="guardrail-header">
        <AlertTriangle size={20} />
        <strong>{title || (type === 'error' ? 'Invalid Combination' : 'Caution')}</strong>
      </div>
      <div className="guardrail-content">
        {children}
      </div>
    </div>
  );
};

export default GuardrailWarning;
